













































































































































































































































































































































































































import Vue from 'vue'
import { mapState, mapGetters, mapActions } from 'vuex'
import SellerInfo from '~/components/car/classifieds/view/partials/seller/SellerInfo.vue'
import UtilButtons from '~/components/car/classifieds/view/partials/UtilButtons.vue'
import ViewMobileInfoWrapper from '~/components/car/classifieds/view/partials/ViewMobileInfoWrapper.vue'
import CompareViewService from '~/services/compare/CompareViewService'
import UserVerificationChecker from '~/services/user/UserVerificationChecker'
import Title from '~/components/car/classifieds/view/partials/Header/Title.vue'
import ImageGallery from '~/components/car/classifieds/view/partials/ImageGallery.vue'
import Specifications from '~/components/car/classifieds/view/partials/Specifications.vue'
import { CLASSIFIED_VIEW_NS } from '~/store/modules/shared/classifieds/view/state'
import { USER_AGENT_NS } from '~/store/modules/shared/userAgent/state'
import Price from '~/components/car/classifieds/view/partials/Price/Price.vue'
import { CategoryId } from '~/models/category/types'
import { USER_NS } from '~/store/modules/shared/user/state'
import CAdmanAd from '~/components/shared/configurable/ad/CAdmanAd.vue'
import { ADS_NS } from '~/store/modules/shared/ads/state'
import ClassifiedViewAd from '~/components/car/classifieds/view/ClassifiedViewAd.vue'
import InstallmentsService from '~/services/classified/finance/InstallmentsService'
import RelatedClassifiedsAndSearches from '~/components/shared/classified/view/RelatedClassifiedsAndSearches.vue'
import { elementLargerThanScreen } from '~/utils/dom'
import OffersButton from '~/components/shared/classified/offers/OffersButton.vue'
import ClassifiedBadges from '~/components/car/classifieds/view/ClassifiedBadges.vue'
import { Position } from '~/models/app/position'
import CTabs from '~/components/shared/configurable/tab/CTabs.vue'
import CTab from '~/components/shared/configurable/tab/CTab.vue'
import CCard from '~/components/shared/configurable/card/CCard.vue'
import KeyFeaturesInColumns from '~/components/car/classifieds/view/partials/key-features/KeyFeaturesInColumns.vue'
import DealerSiteService from '~/services/dealers/site/DealerSiteService'
import AuditsButton from '~/components/shared/classified/audits/AuditsButton.vue'
import CClassifiedFavoriteButton from '~/components/shared/configurable/classified/bucket/favorite/CClassifiedFavoriteButton.vue'
import CPosting from '~/components/shared/configurable/ad/CPosting.vue'
import Notes from '~/components/car/classifieds/view/partials/Notes.vue'
import { defineComponent } from '@nuxtjs/composition-api'
import { OnlineLoanType } from '~/constants/loan/loans'

export default defineComponent({
  components: {
    CPosting,
    AuditsButton,
    LoanSection: () =>
      import(
        '~/components/car/classifieds/view/partials/loans/LoanSection.vue'
      ),
    OffersButton,
    CAdmanAd,
    PerpetratorInfo: () =>
      import('~/components/car/classifieds/view/admin/PerpetratorInfo.vue'),
    CCardHeader: () =>
      import('~/components/shared/configurable/card/CCardHeader.vue'),
    PromoteBlock: () =>
      import('~/components/car/classifieds/view/partials/PromoteBlock.vue'),
    Extras: () =>
      import('~/components/car/classifieds/view/partials/Extras.vue'),
    Certificates: () =>
      import('~/components/car/classifieds/view/partials/Certificates.vue'),
    ExternalCertificates: () =>
      import(
        '~/components/car/classifieds/view/partials/ExternalCertificates/ExternalCertificates.vue'
      ),
    Notes,
    Description: () =>
      import('~/components/car/classifieds/view/partials/Description.vue'),
    ProtectedUtilButtons: () =>
      import(
        '~/components/car/classifieds/view/partials/ProtectedUtilsButtons/ProtectedUtilButtons.vue'
      ),
    Finance: () => import('../partials/finance/Finance.vue'),
    UtilButtons,
    CFloatingContactParking: () =>
      import('~/components/shared/configurable/CFloatingContactParking.vue'),
    Map: () => import('~/components/car/classifieds/view/partials/Map.vue'),
    PriceChangesChart: () =>
      import(
        '~/components/car/classifieds/view/partials/PriceChangesChart.vue'
      ),
    PriceStats: () =>
      import('~/components/car/classifieds/view/partials/PriceStats.vue'),
    Contact: () =>
      import('~/components/car/classifieds/view/partials/Contact.vue'),
    CAnonPrompt: () =>
      import('~/components/shared/configurable/user/CAnonPrompt.vue'),
    Price,
    Title,
    ImageGallery,
    Specifications,
    ViewMobileInfoWrapper,
    KeyFeaturesInColumns,
    QuickSellerInfo: () =>
      import('~/components/shared/classified/view/QuickSellerInfo.vue'),
    SellerInfo,
    VerifiedUser: () =>
      import('~/components/car/classifieds/view/partials/VerifiedUser.vue'),
    ClassifiedBadges,
    CTabs,
    CTab,
    CCard,
    InstallmentsInfo: () =>
      import(
        '~/components/car/classifieds/view/partials/finance/InstallmentsInfo.vue'
      ),
    LeasingInfo: () =>
      import(
        '~/components/car/classifieds/view/partials/finance/LeasingInfo.vue'
      ),
    ClassifiedViewAd,
    RelatedClassifiedsAndSearches,
    CClassifiedFavoriteButton,
    OnlyTradesAlert: () =>
      import('~/components/car/classifieds/view/partials/OnlyTradesAlert.vue'),
    TradesBlock: () =>
      import('~/components/car/classifieds/view/partials/TradesBlock.vue'),
    PiraeusLoanButton: () =>
      import(
        '~/components/plot/classifieds/view/piraeus-loan/PiraeusLoanButton.vue'
      )
  },
  data() {
    return {
      goToMessagesOnLoad: false,
      contactWrapper: null,
      forceBottom: false,
      notesModalVisible: false,
      activeFinanceTab: 1,
      isFormVisible: false,
      isShowMoreExpanded: false
    }
  },
  computed: {
    componentInstance(): Vue {
      return this
    },
    compareViewService() {
      return this.$dep(CompareViewService)
    },
    userVerificationChecker() {
      return this.$dep(UserVerificationChecker)
    },
    ...mapState(ADS_NS, {
      showAdmanAds: state => state.showAdmanAds
    }),
    ...mapState(CLASSIFIED_VIEW_NS, {
      classified: state => state.classified,
      refs: state => state.refs,
      seller: state => state.seller,
      showContact: state => state.showContact,
      showContactPrompt: state => state.showContactPrompt,
      classifiedId: state => state.classifiedId,
      leasing: state => state.leasing,
      installments: state => state.installments,
      notes: state => state.notes,
      currentUser: state => state.currentUser,
      audits: state => state.audits
    }),
    ...mapGetters(CLASSIFIED_VIEW_NS, {
      userCanViewPriceChangesChart: 'userCanViewPriceChangesChart',
      userCanViewPriceStats: 'userCanViewPriceStats',
      isWanted: 'isWanted',
      isDamaged: 'isDamaged',
      isForRent: 'isForRent',
      isPromoted: 'isPromoted',
      isDealersOnly: 'isDealersOnly',
      hasLeasing: 'hasLeasing',
      isNew: 'isNew',
      isBoatClassified: 'isBoatClassified',
      sellerIsAnonymous: 'sellerIsAnonymous',
      sellerIsGuest: 'sellerIsGuest',
      sellerIsSingle: 'sellerIsSingle',
      classifiedIsDeleted: 'isDeleted',
      classifiedIsRemoved: 'isRemoved',
      classifiedIsNonPublic: 'isNonPublic',
      classifiedIsHidden: 'isHidden',
      isPlotClassified: 'isPlotClassified',
      shouldShowProtectedUtilButtons: 'shouldShowProtectedUtilButtons',
      userCanViewNotes: 'userCanViewNotes',
      userIsAdminOrOwner: 'userIsAdminOrOwner',
      canViewPromotionInfo: 'canViewPromotionInfo',
      adsKeyValues: 'getKeyValues',
      paidClassified: 'paidClassified',
      getMonthlyInstallmentAmount: 'getMonthlyInstallmentAmount',
      isMapVariant: 'isMapVariant',
      isOnlyTrades: 'isOnlyTrades',
      showLoanSection: 'showLoanSection',
      showFinance: 'showFinance',
      sellerIsBlacklistedSuspiciousOrFraudster:
        'sellerIsBlacklistedSuspiciousOrFraudster',
      isOwn: 'isOwn',
      shortVideos: 'getShortVideos'
    }),
    ...mapGetters(USER_AGENT_NS, {
      isMobile: 'isMobile',
      isPc: 'isPc'
    }),
    ...mapGetters(USER_NS, {
      userHasPermission: 'hasPermission',
      userIsAdmin: 'isAdmin'
    }),
    monthlyInstallmentAmount() {
      return this.getMonthlyInstallmentAmount(this.$dep(InstallmentsService))
    },
    categoryId(): number {
      return this.$dep(CompareViewService).getViewClassifiedCategoryId()
    },
    showPromoBadge() {
      if (this.isPromoted) {
        return this.$route.query['from-promotion'] || this.userIsAdminOrOwner
      }
      return false
    },
    isExternalCertificatesVisible() {
      return (
        this.classified.external_certificates &&
        Object.keys(this.classified.external_certificates).length > 0
      )
    },
    isInterestZero() {
      return this.classified?.finance?.options?.interestPercentage === 0
    },
    hasTrades() {
      return !!Object.keys(this.classified?.trades?.categories || {}).length
    },
    position() {
      return Position
    },
    isDealerSite() {
      return this.$dep(DealerSiteService).routeIsOfDealerSite()
    },
    isPlotCategory() {
      return this.classified.category_ids.includes(CategoryId.PLOT)
    },
    showAuditsButton() {
      return Boolean(this.audits?.available)
    },
    OnlineLoanType() {
      return OnlineLoanType
    }
  },
  async updated() {
    await this.$nextTick()
    this.forceBottom = elementLargerThanScreen(this.$refs.rightcol)
  },
  mounted() {
    this.contactWrapper = this.$refs.contactWrapper
    if (this.refs && this.refs.goToMessagesOnLoad) {
      this.goToMessagesOnLoad = this.refs.goToMessagesOnLoad
    }
    this.$store.commit('classifieds/view/SET_REFS', null)
    this.forceBottom = elementLargerThanScreen(this.$refs.rightcol)
  },
  methods: {
    ...mapActions(CLASSIFIED_VIEW_NS, {
      scrollToLeasingPartial: 'scrollToLeasingPartial',
      classifiedParkedStateChanged: 'classifiedParkedStateChanged',
      scrollToFinance: 'scrollToFinance'
    }),
    handlePriceChartUpdate() {
      this.forceBottom = elementLargerThanScreen(this.$refs.rightcol)
    },
    handleSetTab(tab: number) {
      this.scrollToFinance()
      this.activeFinanceTab = tab
    },
    handleContactVisibilityChange(visible: boolean) {
      this.isFormVisible = visible
    },
    handleSpecificationExpand(expanded: boolean) {
      this.isShowMoreExpanded = expanded
    },
    handleExtrasExpand(expanded: boolean) {
      this.isShowMoreExpanded = expanded
    }
  }
})
